import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-control-quality-modal',
  templateUrl: './control-quality-modal.component.html',
  styleUrls: ['./control-quality-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlQualityModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}
}
